import React, {FC} from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { SupplierInvoiceSearchCriteria  } from "../../../types/model/criteria/invoice/SupplierInvoiceSearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  SupplierInvoiceSortByType,
  SupplierInvoiceSortParams
} from "../../../types/model/params/sortParams/SupplierInvoiceSortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundTextInput,
  BoundDatePicker
} from "../../common/inputs/boundInputs";

export interface SupplierInvoicesSearchParams extends SupplierInvoiceSearchCriteria , SupplierInvoiceSortParams, PageableParams, BoundSearchQuery {}

export interface SupplierInvoicesSortFilterProps {
  query: SupplierInvoicesSearchParams;
  onChange: (newQuery: SupplierInvoicesSearchParams) => void;
}

const SupplierInvoicesSortFilter: FC<SupplierInvoicesSortFilterProps> = ({
  query,
  onChange
}) => {
  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<SupplierInvoicesSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.supplier.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<SupplierInvoicesSearchParams>
          label="Start Date"
          name="startDate"
          value={query?.startDate}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<SupplierInvoicesSearchParams>
          label="End Date"
          name="endDate"
          value={query?.endDate}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<SupplierInvoicesSearchParams>
          label="Booking Number"
          name="bookingNumber"
          value={query?.bookingNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<SupplierInvoicesSearchParams>
          label="Invoice Number"
          numeric
          name="invoiceNumber"
          value={query?.invoiceNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<SupplierInvoicesSearchParams, SupplierInvoiceSortByType>
          query={query}
          defaultSortBy="TRANSACTION_NUMBER"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { SupplierInvoicesSortFilter };